import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
/**
 * A store that behaves like https://github.com/marcuswestin/store.js but writes
 * to sessionStorage instead of localStorage, because some things you want to be
 * accessible to only a single browser window/tab.
 */
export var SessionStore = /*#__PURE__*/function () {
  function SessionStore(storage) {
    _classCallCheck(this, SessionStore);
    var newStorage = storage;
    if (newStorage === void 0) {
      // Chrome raises a DOMException when trying to access sessionStorage if
      // it has been disabled
      try {
        newStorage = window.sessionStorage;
      } catch (_unused) {
        // continue regardless of error
      }
    }
    this.storage = newStorage;
    this.enabled = this.checkStorageEnabled();
  }
  return _createClass(SessionStore, [{
    key: "checkStorageEnabled",
    value: function checkStorageEnabled() {
      if (!this.storage) {
        return false;
      }
      var testKey = 'storageCheck';
      var testValue = 'just checking';
      var result;
      try {
        this.set(testKey, testValue);
        result = this.get(testKey);
      } catch (_unused2) {
        // continue regardless of error
      }
      return result === testValue;
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.storage.getItem(key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      if (value) {
        return this.storage.setItem(key, value);
      } else {
        return this.remove(key);
      }
    }
  }, {
    key: "remove",
    value: function remove(key) {
      return this.storage.removeItem(key);
    }
  }]);
}();
var newSessionStore = new SessionStore();
export { newSessionStore as sessionStore };